<style>
    .sample-label {
        position: absolute !important;
        background-color:rgba(0, 0, 0, 0) !important;
        border-color:rgba(0, 0, 0, 0) !important;
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
		font-weight: 700;
		text-shadow: 
			-1px -1px 0px white,
			0px -1px 0px white,
			1px -1px 0px white,
			-1px  0px 0px white,
			1px  0px 0px white,
			-1px  1px 0px white,
			0px  1px 0px white,
			1px  1px 0px white;
    }

    .leaflet-tooltip-top:before,
    .leaflet-tooltip-bottom:before,
    .leaflet-tooltip-left:before,
    .leaflet-tooltip-right:before {
        position: absolute !important;
        pointer-events: none !important;
        border: 6px solid transparent !important;
        background: transparent !important;
        content: "" !important;
    }

    .info {
        padding: 6px 8px;
        background: white;
        background: rgba(255,255,255,0.6);
        box-shadow: 0 0 5px rgba(0,0,0,0.1);
        border-radius: 5px;
    }

    .info h4 {
        margin: 0 0 5px;
        color: #777;
    }
</style>
<template>
	<div>
		<div class="flex py-2 m-2 px-4">
			<div class="flex-1 text-left">
				<p class="text-lg font-extrabold">Välj fält som ska läggas till på pappret</p> 
				<p class="text-md font-light mt-2" v-text="customer.id + ' ' + customer.title"></p>
				<p class="text-sm font-thin mt-2">Klicka på ett fält för att välja det eller rita ut med ritverktyget kring de fält du vill skriva ut. När du valt dina fält klicka på knappen "Lägg till valda fält".</p>
			</div>
			<div class="flex-1">
				<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
					<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
				</button>
			</div>
		</div>
        <div id="map" class="h-screen-75 border-t border-b border-grey-light">

			<div v-if="selectedPolygons.length" class="absolute pin-r pin-t mt-12 z-leaflet">
				<button @click="addSelectedPolygons()" class="flex items-center w-35 py-2 mt-4 ml-6 pr-2 pl-2 mr-2 text-sm text-center text-white block bg-blue hover:bg-blue-dark rounded shadow-light font-bold">
					+ Lägg till valda fält
				</button>
			</div>

			<div class="absolute bg-grey-lightest pin-l pin-t mt-2 border ml-16 z-leaflet shadow-lg rounded-lg overflow-hidden">
				<div class="px-6 pt-4 mb-4">
					<label class="ml-2 radiobutton-container">
						<input type="radio" :value="false" v-model="drawPolygon">
						<span class="radiobutton"></span>
						<span class="radiobutton-text font-bold">Markera polygoner</span>
					</label>
					<label class="ml-2 radiobutton-container">
						<input type="radio" :value="true" v-model="drawPolygon">
						<span class="radiobutton"></span>
						<span class="radiobutton-text font-bold">Rita ut fältgränser</span>
					</label>
					<label class="ml-2 checkbox-container">
						<input type="checkbox" v-model="useBackgroundMap">
						<span class="checkmark"></span>
						<span class="checkmark-text font-bold">Hämta bakgrundskarta</span>
					</label>
				</div>
			</div>

			<div v-if="backgroundPolygon" class="absolute pin-r pin-b mb-6 z-leaflet">
				<button @click="clearBackgrundPolygon()" class="flex items-center w-35 py-2 mt-4 ml-6 pr-2 pl-2 mr-2 text-sm text-center text-white block bg-red hover:bg-red-dark rounded shadow-light font-bold">
					Rensa markerad bakgrundskarta
				</button>
			</div>
		</div>

	<div class="w-full bg-grey-lightish rounded-b pb-16">
		<div class="float-left ml-4 mt-4">
			<button @click="goBack()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-light font-bold">
				<svg class="text-white fill-current w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
				Välj annat årtal
			</button>
		</div>
	</div>

	</div>
</template>

<script>

import axios from 'axios'
import uuid from 'uuid';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-imageoverlay-rotated';
import pointInPolygon from '@turf/boolean-point-in-polygon';
import layerContainsPolygon from '@turf/boolean-contains';
import flattenMultiPolygon from '@turf/flatten';
import geojsonArea from '@mapbox/geojson-area';

import interpolationImages from '@/mixins/interpolationImages';
import selectablePolygons from '@/mixins/selectablePolygons';
import leafletDrawSettings from '@/mixins/leafletDrawSettings';

import { mapGetters } from 'vuex'

export default {
	name: 'SamplingMap',
	props: ['page_id'],
	mixins: [interpolationImages, selectablePolygons],
	
	data() {
		return {
			map: null,

			samples: [],
			samplesGeoJson: [],
			polygons: [],
			selectedPolygons: [],
			imageLayers: [],
			drawnItems: [],

			drawPolygon: false,
			useBackgroundMap: false,
			backgroundPolygon: null,
			selectedTileLayer: {
				current: null,
				selectedByUser: 'Lantmäteriet',
				layerChanged: false,
			},

			tileLayers: {
                "Lantmäteriet": L.tileLayer('https://api.lantmateriet.se/open/topowebb-ccby/v1/wmts/token/d17d5440-d4cb-3b2b-93cd-2c491b6f69f5/?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=topowebb_nedtonad&STYLE=default&TILEMATRIXSET=3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/png'),
                "Karta": L.tileLayer('https://api.mapbox.com/styles/v1/simtrax/civ4agfq7000m2ilcp4c87hot/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2ltdHJheCIsImEiOiI4ZjhhODc3ZjA5NDg4YmUyOWI5N2I1ODkxYjJkMGMwMCJ9.z3UUzcUcCZWVqBIvuhsQoQ', {attribution: '<a href="https://www.mapbox.com/about/maps/">© MapBox</a> | <a href="http://openstreetmap.org/copyright">© OpenStreetMap</a> | <a href="http://mapbox.com/map-feedback/" class="mapbox-improve-map">Improve this map</a>'}),
                "Flygfoto": L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'})
			}
		}
	},

	computed: {

		...mapGetters({
			customer:		'customer/customer',
			year:			'customer/year',
		}),
        
        selectedPolygon() {
            if(this.selectedPolygons.length == 1) {
                return this.selectedPolygons[0]
            }
            return null
        },
	
	},

	mounted() {
		this.initiateMap()
		this.fetchPolygonsAndSamples()
	},
    
    beforeDestroy() {
        if(this.map) {
            this.map.remove()
        }
    },

	methods: {

		/**
		 * 	Send the selected polygons to the current page.
		 * 	Send all samples, and mark which ones are inside one of the selected polygons
		 */
		addSelectedPolygons() {
			let samples = []
			this.samples.eachLayer(sample => samples.push(sample.feature))
			
			this.selectedPolygons.forEach(polygon => {
				polygon.feature.properties.samples = {
					features: [],
					type: "FeatureCollection"
				}

				samples.forEach(sample => {
					if(!sample.properties.isInside && pointInPolygon(sample, polygon.toGeoJSON())) {
						sample.properties.isInside = true
					}
				})
			})

			let polygons = this.selectedPolygons.map(polygon => {
				return polygon.toGeoJSON()
			})
			
			let featureCollection = {
				features: polygons,
				type: "FeatureCollection"
			}

			bus.$emit('add-polygons-to-page', {
				id: this.page_id, 
				featureCollection: featureCollection,
				backgroundPolygon: this.backgroundPolygon ? this.backgroundPolygon.toGeoJSON() : null,
				samples: samples
			})
		},

		/**
		 * 	Will clear the year-attribute in the store which
		 * 	will redicect the user to the sampling-index view
		 */
		goBack() {
			this.$store.dispatch("customer/CLEAR_YEAR")
		},
		
        /**
        *   Initiate the leaflet map
        *
        */
        initiateMap() {
            this.map = L.map('map', {
                layers: [this.tileLayers.Lantmäteriet],
                maxZoom: 18,
			})

			L.control.scale({imperial: false, maxWidth: 200}).addTo(this.map);

			let controller = L.control.layers(this.tileLayers).addTo(this.map)
			controller._layersLink.id = 'layer-selector'

            // Ritade figurer sparas här
			this.drawnItems = L.featureGroup()
			this.map.addLayer(this.drawnItems)

			this.addMergeButton()
			
            // "Ritverktygen" läggs till på kartan
            this.map.addControl(new L.Control.Draw({
                edit: {
					featureGroup: this.drawnItems,
					remove:false,
                },
                draw: {
                    polyline: true,
                    polygon: true,
                    circle: false,
                    point: false,
                    rectangle: true,
                    marker: false,
                    layers: false,
                    circlemarker: false,
                }
			}))

			// After a polygon has been drawn, it will check what polygons are within the polygon
			this.map.on(L.Draw.Event.CREATED, event => this.layerDrawn(event, event.layer))
			this.map.on('draw:edited', event => this.layerEdited(event))

			this.map.on('zoomend', e => {
				this.changeLayers()
			});

			this.map.on('baselayerchange', e => {
				// Register if the user changed the layer
				if(e && !this.selectedTileLayer.layerChanged) {
					this.selectedTileLayer.selectedByUser = e.name
				}
				this.selectedTileLayer.layerChanged = false
			})

		},

		addMergeButton() {
			let customControl = L.Control.extend({
				options: {
					position: 'topleft' 
				},
				
				onAdd: (map) => {
					var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom merge-background');
 
					container.style.backgroundColor = 'white';
					container.style.width = '35px';
					container.style.height = '35px';
					container.title = 'Slå ihop polygoner';
					container.style['background-image'] = "<svg class='w-2 h-2' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'><g><path d='M390,122V0H0v390h122v122h390V122H390z M122,360H30V30h330v92H122V360z M482,482H152v-92h238V152h92V482z'/></g></svg>"
				
					container.onclick = () => {
						this.mergePolygons()
					}
					return container;
				},
			});

			this.map.addControl(new customControl());
		},

		/**
		 * Will change the tileLayer if the zoom is larger than 15
		 * and if the layer is 15 or less the layer will change back
		 * to the users choice
		 */
		changeLayers() {
			if (this.map.getZoom() > 15) {
				if(this.selectedTileLayer.current !== 'Flygfoto') {
					this.selectedTileLayer.layerChanged = true
					if(this.selectedTileLayer.current) {
						this.map.removeLayer(this.tileLayers[this.selectedTileLayer.selectedByUser]);
					}
					this.map.addLayer(this.tileLayers.Flygfoto);
					this.selectedTileLayer.current = 'Flygfoto'
				}
			} else {
				if(this.selectedTileLayer.current === 'Flygfoto' && this.selectedTileLayer.selectedByUser !== 'Flygfoto') {
					this.selectedTileLayer.layerChanged = true
					this.map.removeLayer(this.tileLayers[this.selectedTileLayer.current]);
					this.map.addLayer(this.tileLayers[this.selectedTileLayer.selectedByUser]);
					this.selectedTileLayer.current = this.selectedTileLayer.selectedByUser
				}
			}
		},

		layerDrawn(event, layer) {
			let selectedPolygons = []
			
			if(event.layerType == 'polyline') {
				
                if(this.selectedPolygon) {
                    this.splitPolygon(layer.toGeoJSON())
                } else {
					bus.$emit('show-notification', 'Kunde inte dela', 'Markera det fält du vill dela')
				}
				
			} else if(event.layerType == 'polygon' && this.drawPolygon) {
				// Will add the drawn polygon to the map and select it
				layer.feature = {
					properties: {id: uuid.v4()},
					geometry: layer.toGeoJSON().geometry,
					type: "Feature"
				}

				layer.setStyle(this.getDefaultPolygonStyle())
				layer.on("click", event => this.userSelectedAPolygon(layer, false));
				layer.addTo(this.map);
				this.userSelectedAPolygon(layer, false)
				// Add the layer to the drawnItems so that it can be edited 
				this.drawnItems.addLayer(layer)
				
			} else {
				this.selectPolygonsInsideDrawnPolygon(layer)

				if(this.useBackgroundMap) {
					let item = layer

					if(event.layerType == 'polygon') {
						item = L.rectangle(layer.getBounds())
					}

					item.setStyle({
						color: "blue",
						weight: 3,
						opacity: 0.9,
						fillOpacity: 0,
						fillColor: "blue"
					})
					this.drawnItems.addLayer(item)
					this.drawnItems.bringToBack()
					this.backgroundPolygon = item
				}
			}
		},

		layerEdited(event) {
			event.layers.eachLayer(layer => {
				if(!layer.feature) {
					this.selectPolygonsInsideDrawnPolygon(layer)
				}
			})
		},

		selectPolygonsInsideDrawnPolygon(layer) {
			this.polygons.eachLayer(multipolygon => {
				flattenMultiPolygon(multipolygon.toGeoJSON()).features.forEach(polygon => {
					if(layerContainsPolygon(layer.toGeoJSON(), polygon)) {
						let polygonAlreadySelected = this.selectedPolygons.some(polygon => {
							return polygon.feature.properties.id === multipolygon.feature.properties.id
						})
						if(!polygonAlreadySelected) {
							setTimeout(() => { 
								this.userSelectedAPolygon(multipolygon, false)
							}, 1);
						}
					}
				})
			})
		},
		
        /**
         * Fetch all polygons and samples
         * When both requests are done start adding them to the map
         * in the correct order.
         */
        fetchPolygonsAndSamples() {
            axios.all([
                axios.get('polygon/' + this.customer.id +'/year/'+ this.year),
                axios.get('sample/' + this.customer.id + '/' + this.year + '/geojson'),
            ])
            .then(axios.spread((polygonsResponse, samplesResponse) => {
                this.polygons = JSON.parse(polygonsResponse.data[0].features)
				this.samples = JSON.parse(samplesResponse.data[0].features)
				this.samplesGeoJson = this.samples

				this.retrieveBackgroundMap()
				this.addData()
            }));
        },

        /**
         *  Adds the samples and the polygons to the map
         */
        addData() {
            this.addSamples(this.samples)
            this.addPolygons(this.polygons)

			this.changeSampleText('provnr')
			
			// Add the polygons to the drawnItems layer so that they can be edited
			this.polygons.eachLayer(layer => {
				this.drawnItems.addLayer(layer)
			})
		},
		
		/**
		 * Uses the polygons to match any backgroundimages
		 */
		retrieveBackgroundMap() {
			if(this.polygons) {
				let polygons = this.polygons.map(polygon => JSON.stringify(polygon.geometry))
	
				axios.post('print/intersecting/backgroundimage', {
					polygons: polygons
				}).then(response => {
					this.addBackgroundImages(response.data)
				})
			}
		},

		/**
		 * The background images that intersected the polygons are added to the map
		 */
		addBackgroundImages(images) {
			images.forEach(image => {
				let geoJson = JSON.parse(image.geojson)

				let topLeft = geoJson.coordinates[0][0].reverse()
				let topRight = geoJson.coordinates[0][3].reverse()
				let lowerLeft = geoJson.coordinates[0][1].reverse()

				this.imageLayers.push(L.imageOverlay.rotated(image.imageUrl, topLeft, topRight, lowerLeft).addTo(this.map))
			})
		},

        /**
         *   Add the polygons to the map
         *   When added fit the map bounds to the polygon outer bounds
         */
        addPolygons(polygons) {
			this.polygons = L.geoJson(null, {
				onEachFeature: (feature, layer) => {
					((layer, properties) => {
						layer.setStyle(this.getDefaultPolygonStyle())
					})(layer, feature.properties);

					layer.feature.properties.id = uuid.v4()

					layer.on("click", event => {
						let panToPolygon = false
						this.userSelectedAPolygon(layer, panToPolygon)
					});
				}
			}).addTo(this.map);

            if(polygons) {
				polygons.forEach(multiPolygon => {
					flattenMultiPolygon(multiPolygon).features.forEach(polygon => {
						this.polygons.addData(polygon)
					})
				})

                this.map.fitBounds(this.polygons.getBounds())
            } else {
                // We try to make sure that the samples are loaded by waiting 500 ms
                setTimeout(() => {
                    this.map.fitBounds(this.samples.getBounds());
                }, 500)
            }

            this.initiateMapListener()
        },

        /**
        *   Split polygon plotted in the map.
        *   Returns a new polygon that is split.
        */
        splitPolygon(polyline) {
            axios.post('polygon/split', {
                polyline: JSON.stringify(polyline.geometry),
                multipolygon: JSON.stringify(this.selectedPolygon.toGeoJSON().geometry)
            })
            .then(response => {
                // Save the old gid so the newly split polygons can use it.
                let gid = this.selectedPolygon.feature.properties.gid;

                this.removeLayer(this.selectedPolygon);
                this.deselectPolygon(this.selectedPolygon.feature.properties.id);

                JSON.parse(response.data[0].multipolygon).geometries.forEach(geometry => {
                    this.addPolygon(this.createFeature(geometry, gid))
                })
            })
            .catch(function (error) {
				console.log(error)
				bus.$emit('show-notification', 'Fältet gick inte att dela')
            });
		},
		
		/**
		 * Will merge the two selected polygons
		 * If two polygons are note selected, a notitifcation will be shown
		 */
		mergePolygons() {
            if(this.selectedPolygons.length == 2) {
				axios.post('/polygon/union', {
                    multipolygon1: JSON.stringify(this.selectedPolygons[0].feature.geometry),
                    multipolygon2: JSON.stringify(this.selectedPolygons[1].feature.geometry)
                })
                .then(response => {
                    this.removeLayer(this.selectedPolygons[0]);
					this.removeLayer(this.selectedPolygons[1]);
					
					let gid
					if(this.selectedPolygons[0].feature.properties.gid === this.selectedPolygons[1].feature.properties.gid) {
						gid = this.selectedPolygons[0].feature.properties.gid
					} else {
						gid = this.selectedPolygons[0].feature.properties.gid + '-' + this.selectedPolygons[0].feature.properties.gid
					}
					// Create the returned polygon
					this.addPolygon(this.createFeature(JSON.parse(response.data[0].multipolygon), gid))
					
					this.selectedPolygons = []
                })
                .catch(function (error) {
					bus.$emit('show-notification', 'De två fälten gränsar inte till varandra')
				});
            } else {
				bus.$emit('show-notification', 'Välj exakt två fält för att slå samman')
            }
		},

        /**
        *   Removes previously selected polygon
        */
        removeLayer(layer) {
            this.map.removeLayer(layer);
            this.polygons.removeLayer(layer);
        },

        /**
         *  Add a polygon to the already initated polygons layer
         */
        addPolygon(polygon) {
            this.polygons.addData(polygon)

            // Invalidate map to eliminate rendering issues
            setTimeout(() => {
                this.map.invalidateSize()
            }, 10)
        },
        
        /**
         *  Create a new GeoJson feature from the geometry,
         *  save the gid as a property and calculate the area as well.
         *  Will force the geometry to a MultiPolygon.
         * 
         */
        createFeature(geometry, gid) {
            return {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: geometry.coordinates
                },
                properties: {
                    gid: gid,
                    areal: +(geojsonArea.geometry(geometry) / 10000).toFixed(1)
                }
            }
        },
		
		clearBackgrundPolygon() {
			this.backgroundPolygon.removeFrom(this.map)
			this.backgroundPolygon = null
		},

		dismissModal() {
			this.$emit('closeModal')
		}

	}
}
</script>

<style>
.merge-background {
    background-image: url(/img/merge.svg);
	background-size: 60%;
	background-repeat: no-repeat;
	background-position: center;
}	
.leaflet-control-custom:hover {
	background-color: #f4f4f4 !important;
	cursor: pointer;
}	
</style>